module.exports = __webpack_public_path__ + "static/quest_mit_r-2f6ddb67f0f2700bd614c945fabc6659.png";